import { useInfiniteQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { GetPlacementParams } from './get-placement-param.types';
import { PlacementsFilters } from './use-placements-page.types';
import { placementService } from '../../../../../../services';
import { DEFAULT_PAGE_SIZE } from '../../../../../../../shared/utils/constants';
const INITIAL_PAGE = 0;

const useGetPlacements = ({ fromDate, ...filters }: PlacementsFilters) => {
  const params: GetPlacementParams = {
    fromDate: fromDate ? fromDate.toISO() : undefined,
    companyId: filters.company,
    branchOfficeIds: filters.branchOfficeIds,
    departmentIds: filters.departmentIds,
    jobTypeIds: filters.jobType,
    workerId: filters.worker,
    isFreelance: filters.isFreelance,
    isTempWork: filters.isTempWork,
    states: filters.states,
    page: INITIAL_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
  };

  return useInfiniteQuery({
    queryKey: QUERY_KEYS.placementsWithFilters(params),
    queryFn: async ({ pageParam = 0 }) =>
      await placementService.getAllPlacements({ ...params, page: pageParam }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};

export { useGetPlacements };
